<template>
  <div>
    <v-row>
      <v-col cols="12" class="pt-2 pr-1 pb-0 mt-1">
        <v-autocomplete outlined dense hide-details flat autocomplete="off" v-model="modelObj.customerid" :items="getCustomers"
          item-text="name" item-value="id" @change="getCustomerRelatedData" :label="$t('message.order.customer')"></v-autocomplete>
      </v-col>
      <v-col cols="12" class="pt-2 pr-1 pb-0 mt-1">
        <v-text-field outlined dense hide-details v-model="modelObj.yourreference" flat autocomplete="off"
          :label="$t('message.order.yourReference')"></v-text-field>
      </v-col>
      <v-col cols="12" class="pt-1 pr-1 pb-0 mt-1">
        <h4>{{ $t('message.order.standardOrderText') }}:</h4>
      </v-col>
      <v-col cols="12" class="pt-0 pr-1 pb-0 mt-1">
        <ckeditor :editor="editor" v-model="modelObj.standardsales" :config="editorConfig"></ckeditor>
      </v-col>
    </v-row>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn color="primary" :loading="saveLoading" @click="saveOrderHandler">{{ $t('message.order.pickOrder') }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>
<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  data () {
    return {
      modelObj: {
        standardsales: ''
      },
      saveLoading: false,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'undo',
            'redo'
          ]
        }
      }
    }
  },
  components: {
    'ckeditor': CKEditor.component
  },
  computed: {
    ...mapGetters(['getCustomers'])
  },
  mounted () {
    this.$store.dispatch('getCustomersList')
    this.getSettings()
    this.modelObj.orderdate = moment(new Date()).format('MM.DD.YYYY')
    const currentUserId = this.$store.state.auth.userDetails ? this.$store.state.auth.userDetails.id : ''
    this.modelObj.responsible = currentUserId || ''
    this.modelObj.ourreference = currentUserId || ''
    this.modelObj.state = 'for_production'
    this.modelObj.storesales = true
  },
  methods: {
    getSettings () {
      this.$api.execute('get', 'commonsettings').then(response => {
        let settings = response.data
        if (!this.modelObj.standardsales) this.modelObj.standardsales = settings.standradordertext
      })
    },
    getCustomerRelatedData () {
      this.modelObj.invoiceto = this.modelObj.customerid
      if (this.getCustomers && this.getCustomers.length > 0) {
        let customer = this.getCustomers.find(x => x.id === this.modelObj.invoiceto)
        if (customer) {
          this.modelObj.paymentterms = customer.paymentterm || 0
          this.modelObj.deliveryterms_id = customer.deliveryterms_id || 0
          this.modelObj.paymentmethod1 = customer.paymentmethod1 ? customer.paymentmethod1.toLowerCase() : ''
          this.modelObj.paymentmethod2 = (customer.paymentmethod2 ? +customer.paymentmethod2 : 0)
        } else this.modelObj.paymentterms = 0
      }
    },
    saveOrderHandler () {
      this.saveLoading = true
      this.$api.execute('post', 'orders', this.modelObj)
        .then(response => {
          if (response && response.data) {
            this.$router.push(`/store_sale/${response.data.id}/pick`)
          }
        })
        .finally(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>
<style>
.ck-editor__editable_inline {
  min-height: 100px;
}
</style>
